import React, { useState, useRef, useEffect } from 'react';
import styles from './SearchInput.module.scss';
import { SearchInputProps } from './types';
import Icon from '../Icon';
import { icons } from 'assets';
import { Button } from '..';
import { observer } from 'mobx-react-lite';
import { inject } from 'mobx-react';
import { EDITOR_HOTKEYS_STORE } from 'store';

const SearchInput = (props: SearchInputProps) => {
  const {
    className, searchByOptions, onChange, onFocus,
    [EDITOR_HOTKEYS_STORE]: {
      searchOnFocus,
      setSearchOnFocus
    }
  } = props;

  const myRef = useRef(null);
  const inputRef = useRef(null);
  const [focused, setFocused] = useState(false);
  const [searchBy, setSearchBy] = useState('Search By');
  const [searchFor, setSearchFor] = useState('');
  const [showFilterMenu, setShowFilterMenu] = useState(false);

  useEffect(() => {
    if (!onFocus || !focused) return;

    onFocus();
  }, [focused, onFocus]);

  useEffect(() => {
    if (!onChange) return;

    const timeoutId = setTimeout(() => onChange(searchFor, searchBy), 300);

    return () => clearTimeout(timeoutId);
  }, [searchBy, searchFor, onChange]);

  useEffect(() => {
    if (!searchOnFocus) return;

    inputRef.current.focus();
    setSearchOnFocus(false);
  }, [searchOnFocus, setSearchOnFocus]);

  const handleOutsideClick = e => {
    if (myRef.current.contains(e.target)) return;

    setFocused(false);
    setShowFilterMenu(false);
    document.removeEventListener('click', handleOutsideClick, false);
  };

  const handleSearchByClick = () => {
    if (!showFilterMenu) {
      document.addEventListener('click', handleOutsideClick, false);
      setShowFilterMenu(true);
      setFocused(true);
    } else {
      setShowFilterMenu(false);
    }
  };

  const handleOnChange = (searchForValue, searchByValue = searchBy) => {
    searchForValue !== searchFor && setSearchFor(searchForValue);
    searchByValue !== searchBy && setSearchBy(searchByValue);
  };

  const containerStyles = [styles.container];
  focused && containerStyles.push(styles.focused);
  className && containerStyles.push(className);

  return (
    <div
      ref={myRef}
      className={containerStyles.join(' ')}
      style={{ color: focused ? styles.blackClicked : styles.extraLightGrey }}
    >
      {searchByOptions &&
        <div>

          <div
            onClick={handleSearchByClick}
          >
            {searchBy}
            <Icon
              icon={showFilterMenu ? icons.arrowUp : icons.arrowDown}
              className={styles.filterBttnIcon}
            />
          </div>

          {showFilterMenu &&
            <div
              className={styles.filterBttnsContainer}
              onMouseLeave={() => setShowFilterMenu(false)}
            >
              {searchByOptions.map(option =>
                <Button
                  key={option}
                  onClick={() => {
                    setSearchBy(option);
                    setShowFilterMenu(false);
                    setFocused(true);
                  }}
                  className={styles.filterBttn}
                >
                  {option}
                </Button>
              )}
            </div>
          }

        </div>
      }

      <input
        ref={inputRef}
        type='text'
        placeholder='Search'
        autoFocus={focused}
        onMouseDown={e => e.stopPropagation()}
        onChange={e => handleOnChange(e.target.value)}
        onFocus={() => setFocused(true)}
        onBlur={() => setFocused(false)}
        style={{ color: focused ? styles.blackClicked : styles.extraLightGrey }}
      />
      <Icon icon={icons.search} className={styles.searchIcon} />
    </div>
  );
};

export default inject(EDITOR_HOTKEYS_STORE)(observer(SearchInput));
